import '@babel/polyfill';

import React, {
  useState, useEffect, lazy, Suspense,
} from 'react';
import { useCookies } from 'react-cookie';
import {
  isMobileOnly,
  isIE,
} from 'react-device-detect';
import { Texts } from './components/Texts';
import { Loading } from './components/Loading';
import Message from './components/Message';

const MobileVersion = lazy(() => import('./components/MobileVersion'));
const FullVersion = lazy(() => import('./components/FullVersion'));

const App = () => {
  const initialLang = 'ru';
  const langs = [{ code: 'ru', text: 'Ru', oppositeCode: 'en' }, { code: 'en', text: 'En', oppositeCode: 'ru' }];

  const [isLoaded, setIsLoaded] = useState(false);
  const [lang, setLang] = useState(null);
  const [cookies, setCookie] = useCookies(['lang-code']);

  useEffect(() => {
    const cookieLangCode = cookies['lang-code'];
    if (cookieLangCode !== undefined) {
      Texts.setLanguage(cookieLangCode);
      setLang(langs.filter((lng) => lng.code === cookieLangCode)[0]);
    } else {
      const userLangCode = navigator.language || navigator.userLanguage;
      const userLang = langs.filter((lng) => userLangCode.indexOf(lng.code) > -1)[0];

      let initialLangCode = initialLang;
      if (userLang !== undefined) {
        initialLangCode = userLang.code;
      }

      Texts.setLanguage(initialLangCode);
      setLang(langs.filter((lng) => lng.code === initialLangCode)[0]);
      setCookie('lang-code', initialLangCode);
    }

    setIsLoaded(true);
  }, []);

  if (!isLoaded) {
    return null;
  }

  if (isIE) {
    return (<Message messageText={Texts.BrowserIsNotSupported} messageType="error" messageTitle={Texts.ErrorTitle} />);
  }

  const onSetLang = (langCode) => {
    Texts.setLanguage(langCode);
    setCookie('lang-code', langCode);
    setLang(langs.filter((lng) => lng.code === langCode)[0]);
  };

  if (isMobileOnly) {
    return (
      <Suspense fallback={<Loading />}>
        <MobileVersion
          onSetLang={onSetLang}
          oppositeLang={langs.filter((lng) => lng.code === lang.oppositeCode)[0]}
          lang={lang.code}
        />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<Loading />}>
      <FullVersion
        isLoaded={isLoaded}
        onSetLang={onSetLang}
        lang={lang.code}
        oppositeLang={langs.filter((lng) => lng.code === lang.oppositeCode)[0]}
      />
    </Suspense>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js